import PropTypes from 'prop-types';

import Button from '../../oc-button';
import { formatBuyType } from '../format-buy-type';
import { MainCta as CTAWrapper } from '../result-block-styled-components';
import toLower from '../../../OC/PageBuilder/utilities/toLower';

const CallNowCTA = ({ href, label, onClick, track, color }) => (
  <CTAWrapper>
    <Button
      onClick={onClick}
      href={onClick ? undefined : href}
      color={color}
      data-track={track.name}
      data-track-buy-type={formatBuyType(track.buyType)}
      data-track-contractor={track.contractorName}
      data-track-contractor-id={track.contractorId}
      data-track-form-name={track.formName}
      data-track-professional={track.professional}
      data-track-supplier-id={track.supplierId}
      data-track-supplier-name={toLower(track.supplierName)}
    >
      {label}
    </Button>
  </CTAWrapper>
);

CallNowCTA.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  track: PropTypes.shape({
    name: PropTypes.string,
    contractorName: PropTypes.string,
    contractorId: PropTypes.string,
    formName: PropTypes.string,
    professional: PropTypes.string,
    buyType: PropTypes.string,
    supplierId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    supplierName: PropTypes.string,
  }),
  onClick: PropTypes.func,
  color: PropTypes.string,
};

CallNowCTA.defaultProps = {
  href: undefined,
  onClick: undefined,
  track: {},
  color: undefined,
};

export default CallNowCTA;
